/**
 A jQuery function to check if an element is visible in the viewport.
 - See https://stackoverflow.com/a/33979503/5325869 for info
 */
function visible(element) {
  const top_of_element = $(element).offset().top;
  const bottom_of_element = $(element).offset().top + $(element).outerHeight();
  const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
  const top_of_screen = $(window).scrollTop();
  return (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
}

export default visible;
